package com.evoapps.evoshift.ui.user

import androidx.compose.material.icons.filled.Timeline
import evoshift.composeapp.generated.resources.employee_timeline
import evoshift.composeapp.generated.resources.employee_timeline_desc
import evoshift.composeapp.generated.resources.timeline_open
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import androidx.compose.animation.togetherWith
import evoshift.composeapp.generated.resources.employee_owner_partner_rate_hint
import com.evoapps.evoshift.widgets.EvoTopBar
import evoshift.composeapp.generated.resources.saves_saving
import evoshift.composeapp.generated.resources.saves_saving_hint
import com.evoapps.evoshift.widgets.helpAction
import com.evoapps.evoshift.ui.notifications.notificationsAction
import com.evoapps.evoshift.ui.billing.PlanLimitDialog
import com.evoapps.evoshift.ui.util.HelpCentreButton
import com.evoapps.evoshift.ui.util.HelpPage
import com.evoapps.evoshift.domain.model.SystemContractType
import evoshift.composeapp.generated.resources.employee_bank_account
import evoshift.composeapp.generated.resources.employee_payroll_id
import evoshift.composeapp.generated.resources.employee_payroll_id_help
import evoshift.composeapp.generated.resources.employee_address
import evoshift.composeapp.generated.resources.employee_phone
import evoshift.composeapp.generated.resources.invite_share_text
import evoshift.composeapp.generated.resources.employee_add_someone_new
import evoshift.composeapp.generated.resources.employee_add_to_team
import evoshift.composeapp.generated.resources.employee_choose_person
import evoshift.composeapp.generated.resources.employee_from_other_workplaces
import evoshift.composeapp.generated.resources.employee_from_other_workplaces_hint
import evoshift.composeapp.generated.resources.employee_picked_from_other
import com.evoapps.evoshift.domain.usecase.team.OtherWorkplacePerson
import evoshift.composeapp.generated.resources.invite_copied
import evoshift.composeapp.generated.resources.invite_copy
import evoshift.composeapp.generated.resources.invite_ready_body
import evoshift.composeapp.generated.resources.invite_ready_title
import com.evoapps.evoshift.ui.util.label
import evoshift.composeapp.generated.resources.employee_fte_short
import com.evoapps.evoshift.ui.util.asString
import evoshift.composeapp.generated.resources.employee_employer_cost
import evoshift.composeapp.generated.resources.employee_fte
import evoshift.composeapp.generated.resources.employee_rate_effective_from
import evoshift.composeapp.generated.resources.employee_rate_effective_from_hint
import com.evoapps.evoshift.ui.adaptive.contentWidth
import com.evoapps.evoshift.ui.adaptive.ContentMaxWidth
import com.evoapps.evoshift.ui.adaptive.LocalWindowWidthClass
import com.evoapps.evoshift.ui.adaptive.ResponsiveColumns
import com.evoapps.evoshift.ui.adaptive.WideContentMaxWidth
import com.evoapps.evoshift.ui.adaptive.handCursor
import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.core.tween
import androidx.compose.animation.expandVertically
import androidx.compose.animation.shrinkVertically
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Description
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.filled.AccountBalanceWallet
import androidx.compose.material.icons.filled.ContentCopy
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material.icons.filled.Email
import androidx.compose.material.icons.filled.ExpandLess
import androidx.compose.material.icons.filled.ExpandMore
import androidx.compose.material.icons.filled.Lock
import androidx.compose.material.icons.filled.Person
import androidx.compose.material.icons.filled.Settings
import androidx.compose.material.icons.filled.Smartphone
import androidx.compose.material.icons.filled.Groups
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.CenterAlignedTopAppBar
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalClipboard
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.domain.model.UserPermission
import com.evoapps.evoshift.ui.Cream
import com.evoapps.evoshift.ui.DarkGold
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.GoldMetallicBrush
import com.evoapps.evoshift.viewmodels.EmployeeFormEvent
import com.evoapps.evoshift.viewmodels.EmployeeFormViewModel
import com.evoapps.evoshift.widgets.RegularCard
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.material.icons.filled.AccountBalance
import androidx.compose.material.icons.filled.Check
import androidx.compose.material.icons.filled.Home
import androidx.compose.material.icons.filled.Phone
import androidx.compose.material.icons.filled.VpnKey
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardCapitalization
import androidx.compose.ui.unit.sp
import com.evoapps.evoshift.ui.LightGold
import com.evoapps.evoshift.widgets.DataRow
import com.evoapps.evoshift.widgets.DialogAction
import com.evoapps.evoshift.widgets.DialogSection
import com.evoapps.evoshift.widgets.DialogWidth
import com.evoapps.evoshift.widgets.ErrorOnNavy
import com.evoapps.evoshift.widgets.EvoCheckboxRow
import com.evoapps.evoshift.widgets.EvoConfirmDialog
import com.evoapps.evoshift.widgets.EvoDialog
import com.evoapps.evoshift.widgets.EvoDropdown
import com.evoapps.evoshift.widgets.EvoPrimaryButton
import com.evoapps.evoshift.widgets.EvoSecondaryButton
import com.evoapps.evoshift.widgets.EvoSegmented
import com.evoapps.evoshift.widgets.EvoSwitchRow
import com.evoapps.evoshift.widgets.EvoTextField
import com.evoapps.evoshift.widgets.RoleField
import com.evoapps.evoshift.widgets.ProfileSection
import com.evoapps.evoshift.widgets.parseDecimal
import com.evoapps.evoshift.ui.finance.formatMoney
import kotlinx.datetime.todayIn
import androidx.compose.foundation.selection.toggleable
import evoshift.composeapp.generated.resources.employee_works_unpaid
import evoshift.composeapp.generated.resources.employee_counts_in_labour
import evoshift.composeapp.generated.resources.employee_counts_in_labour_hint
import evoshift.composeapp.generated.resources.employee_counts_in_labour_no_wage
import evoshift.composeapp.generated.resources.employee_works_unpaid_hint
import evoshift.composeapp.generated.resources.employee_hidden_in_roster
import evoshift.composeapp.generated.resources.employee_hidden_in_roster_hint
import evoshift.composeapp.generated.resources.dialog_section_access
import evoshift.composeapp.generated.resources.dialog_section_bank
import evoshift.composeapp.generated.resources.dialog_section_contact
import evoshift.composeapp.generated.resources.dialog_section_contract
import evoshift.composeapp.generated.resources.dialog_section_engagement
import evoshift.composeapp.generated.resources.dialog_section_pay
import evoshift.composeapp.generated.resources.field_required
import evoshift.composeapp.generated.resources.number_invalid
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.auth_email
import evoshift.composeapp.generated.resources.availability_start_date
import evoshift.composeapp.generated.resources.cancel
import evoshift.composeapp.generated.resources.done
import evoshift.composeapp.generated.resources.edit
import evoshift.composeapp.generated.resources.employee_app_usage
import evoshift.composeapp.generated.resources.employee_basic_info
import evoshift.composeapp.generated.resources.employee_contract_type
import evoshift.composeapp.generated.resources.employee_copy_link
import evoshift.composeapp.generated.resources.employee_create
import evoshift.composeapp.generated.resources.employee_declared_hours
import evoshift.composeapp.generated.resources.employee_edit_basic_info
import evoshift.composeapp.generated.resources.employee_edit_financial_details
import evoshift.composeapp.generated.resources.employee_edit_permissions
import evoshift.composeapp.generated.resources.employee_edit_private_data
import evoshift.composeapp.generated.resources.employee_financial_details
import evoshift.composeapp.generated.resources.employee_has_app_account
import evoshift.composeapp.generated.resources.employee_hourly
import evoshift.composeapp.generated.resources.employee_invitation_options
import evoshift.composeapp.generated.resources.employee_is_primary
import evoshift.composeapp.generated.resources.employee_model
import evoshift.composeapp.generated.resources.employee_monthly
import evoshift.composeapp.generated.resources.employee_no
import evoshift.composeapp.generated.resources.employee_not_set
import evoshift.composeapp.generated.resources.employee_permission
import evoshift.composeapp.generated.resources.access_open
import evoshift.composeapp.generated.resources.employee_permissions_settings
import evoshift.composeapp.generated.resources.employee_primary_workplace
import evoshift.composeapp.generated.resources.employee_primary_workplace_hint
import evoshift.composeapp.generated.resources.employee_private_data
import evoshift.composeapp.generated.resources.employee_profile
import evoshift.composeapp.generated.resources.employee_rate
import evoshift.composeapp.generated.resources.employee_pay_since
import evoshift.composeapp.generated.resources.employee_pay_next
import evoshift.composeapp.generated.resources.payroll_rate_hourly
import evoshift.composeapp.generated.resources.payroll_rate_monthly
import evoshift.composeapp.generated.resources.employee_rate_unit
import evoshift.composeapp.generated.resources.employee_remove
import evoshift.composeapp.generated.resources.employee_remove_confirm
import evoshift.composeapp.generated.resources.employee_salary
import evoshift.composeapp.generated.resources.employee_salary_unit
import evoshift.composeapp.generated.resources.employee_send_invite_email
import evoshift.composeapp.generated.resources.employee_send_invite_options
import evoshift.composeapp.generated.resources.employee_yes
import evoshift.composeapp.generated.resources.roster_role
import evoshift.composeapp.generated.resources.save
import evoshift.composeapp.generated.resources.settings_more
import evoshift.composeapp.generated.resources.settings_name
import evoshift.composeapp.generated.resources.settings_none
import evoshift.composeapp.generated.resources.settings_skills
import evoshift.composeapp.generated.resources.settings_slot_label_hint
import org.jetbrains.compose.resources.stringResource
import com.evoapps.evoshift.domain.model.ContractType
import com.evoapps.evoshift.util.plainTextClipEntry
import kotlinx.coroutines.launch
import androidx.compose.material.icons.filled.HealthAndSafety
import androidx.compose.material.icons.filled.EditCalendar
import com.evoapps.evoshift.domain.model.Competence
import com.evoapps.evoshift.domain.model.StaffRecordProblem
import com.evoapps.evoshift.widgets.EvoDateField
import com.evoapps.evoshift.widgets.MissingYear
import evoshift.composeapp.generated.resources.employee_terms_history
import com.evoapps.evoshift.widgets.parseIsoDate
import evoshift.composeapp.generated.resources.staff_checks_dates_only
import evoshift.composeapp.generated.resources.employee_documents
import evoshift.composeapp.generated.resources.employee_documents_desc
import evoshift.composeapp.generated.resources.documents_open
import evoshift.composeapp.generated.resources.staff_checks_edit
import evoshift.composeapp.generated.resources.staff_checks_status_only
import evoshift.composeapp.generated.resources.staff_checks_title
import evoshift.composeapp.generated.resources.staff_competence
import evoshift.composeapp.generated.resources.staff_competence_hint
import evoshift.composeapp.generated.resources.staff_medical_exam
import evoshift.composeapp.generated.resources.staff_medical_valid_until
import evoshift.composeapp.generated.resources.staff_notes_edit
import evoshift.composeapp.generated.resources.staff_notes_hint
import evoshift.composeapp.generated.resources.staff_notes_title
import evoshift.composeapp.generated.resources.staff_ohs_training
import evoshift.composeapp.generated.resources.staff_ohs_training_date
import evoshift.composeapp.generated.resources.staff_ohs_valid_before_training
import evoshift.composeapp.generated.resources.staff_ohs_valid_until

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun EmployeeFormScreen(
    viewModel: EmployeeFormViewModel,
    onNavigateBack: () -> Unit,
    onSeePlans: () -> Unit = {},
    /** SH-122: the person's documents (owners, financial managers). */
    onOpenDocuments: (employeeId: String) -> Unit = {},
    /** SH-212: the person's timeline (owners, financial managers). */
    onOpenTimeline: (employeeId: String) -> Unit = {},
    /** SH-270: the person's access per feature (their role and modifications). */
    onOpenAccess: (employeeId: String) -> Unit = {}
) {
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    val snackbarHostState = remember { SnackbarHostState() }
    val clipboard = LocalClipboard.current
    val scope = rememberCoroutineScope()

    state.planLimit?.let { limit ->
        PlanLimitDialog(
            limit = limit,
            onSeePlans = {
                viewModel.onEvent(EmployeeFormEvent.PlanLimitShown)
                onSeePlans()
            }.takeIf { state.planLimitCanChoosePlan },
            onDismiss = { viewModel.onEvent(EmployeeFormEvent.PlanLimitShown) }
        )
    }

    // The invitation's join code: the manager passes it on (the email sender is not live yet).
    state.inviteCode?.let { code ->
        val link = "https://evoshift.app/join?code=$code"
        val shareText = stringResource(Res.string.invite_share_text, code, link)
        var copied by remember(code) { mutableStateOf(false) }
        EvoDialog(
            title = stringResource(Res.string.invite_ready_title),
            icon = Icons.Default.VpnKey,
            onDismiss = { viewModel.onEvent(EmployeeFormEvent.DismissInviteCode) },
            width = DialogWidth.Compact,
            confirm = DialogAction(stringResource(Res.string.done), { viewModel.onEvent(EmployeeFormEvent.DismissInviteCode) }),
            dismiss = DialogAction(
                stringResource(if (copied) Res.string.invite_copied else Res.string.invite_copy),
                {
                    scope.launch {
                        clipboard.setClipEntry(plainTextClipEntry(shareText))
                        copied = true
                    }
                },
                icon = if (copied) Icons.Default.Check else Icons.Default.ContentCopy
            )
        ) {
            Text(stringResource(Res.string.invite_ready_body), color = Color.White.copy(alpha = 0.85f))
            SelectionContainer {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .clip(RoundedCornerShape(16.dp))
                        .background(Color.White.copy(alpha = 0.06f))
                        .padding(vertical = 16.dp, horizontal = 12.dp),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    Text(
                        code,
                        style = MaterialTheme.typography.headlineMedium,
                        fontWeight = FontWeight.Bold,
                        color = LightGold,
                        letterSpacing = 4.sp
                    )
                    Text(link, style = MaterialTheme.typography.bodySmall, color = Color.White.copy(alpha = 0.6f))
                }
            }
        }
    }
    var showBasicInfoEdit by remember { mutableStateOf(false) }
    var showPermissionsEdit by remember { mutableStateOf(false) }
    var showFinancialEdit by remember { mutableStateOf(false) }
    var showPrivateDataEdit by remember { mutableStateOf(false) }
    var showStaffChecksEdit by remember { mutableStateOf(false) }
    var showNotesEdit by remember { mutableStateOf(false) }
    var isMoreExpanded by remember { mutableStateOf(false) }
    var showRemoveConfirmDialog by remember { mutableStateOf(false) }
    // SH-192: the people of the viewer's other workplaces, to add one here.
    var showPeoplePicker by remember { mutableStateOf(false) }

    val errorText = state.error?.asString()

    LaunchedEffect(errorText) {
        errorText?.let {
            snackbarHostState.showSnackbar(it)
            viewModel.onEvent(EmployeeFormEvent.ClearMessage)
        }
    }

    val messageText = state.message?.asString()

    LaunchedEffect(messageText) {
        messageText?.let {
            snackbarHostState.showSnackbar(it)
            viewModel.onEvent(EmployeeFormEvent.ClearMessage)
        }
    }

    LaunchedEffect(state.success, state.showInviteDialogAfterCreation) {
        if (state.success && !state.showInviteDialogAfterCreation) {
            onNavigateBack()
        }
    }

    val isExpanded = LocalWindowWidthClass.current.isExpanded

    Scaffold(
        snackbarHost = { SnackbarHost(snackbarHostState) },
        containerColor = Cream,
        topBar = {
            EvoTopBar(
                title = stringResource(Res.string.employee_profile),
                onBack = onNavigateBack,
                backDescription = stringResource(Res.string.cancel),
                actions = buildList {
                    add(helpAction(HelpPage.TEAM_PERSON))
                    // Edits are saved from the section dialogs, which close at once: the bar shows
                    // "Saving…" (SH-148, for every save of the app) and the form says so too.
                }
            )
        },
        bottomBar = {
            if (!state.isEditMode && state.canEdit) {
                // Same width as the form above it, not the whole window.
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .contentWidth(if (isExpanded) WideContentMaxWidth else ContentMaxWidth)
                        .padding(16.dp)
                ) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(50.dp)
                            .background(GoldMetallicBrush, RoundedCornerShape(12.dp))
                            .handCursor()
                            .clickable(enabled = !state.isSaving) { viewModel.onEvent(EmployeeFormEvent.Submit) },
                        contentAlignment = Alignment.Center
                    ) {
                        // SH-158: "Create" and "Saving…" cross-fade in the full-width button.
                        val reduced = com.evoapps.evoshift.ui.theme.LocalReducedMotion.current
                        androidx.compose.animation.AnimatedContent(
                            targetState = state.isSaving,
                            transitionSpec = {
                                androidx.compose.animation.fadeIn(com.evoapps.evoshift.ui.theme.motionTween(com.evoapps.evoshift.ui.theme.Motion.SHORT_MS, reduced)) togetherWith
                                    androidx.compose.animation.fadeOut(com.evoapps.evoshift.ui.theme.motionTween(com.evoapps.evoshift.ui.theme.Motion.SHORT_MS, reduced))
                            },
                            contentAlignment = Alignment.Center,
                            label = "createEmployeeBusy"
                        ) { saving ->
                            if (saving) {
                                Row(verticalAlignment = Alignment.CenterVertically) {
                                    CircularProgressIndicator(modifier = Modifier.size(20.dp), color = DeepNavy, strokeWidth = 2.dp)
                                    Spacer(Modifier.width(10.dp))
                                    Text(stringResource(Res.string.saves_saving), fontWeight = FontWeight.Bold, color = DeepNavy)
                                }
                            } else {
                                Text(
                                    stringResource(if (state.pickedPerson != null) Res.string.employee_add_to_team else Res.string.employee_create),
                                    fontWeight = FontWeight.Bold,
                                    color = DeepNavy
                                )
                            }
                        }
                    }
                }
            }
        }
    ) { padding ->
        Box(
            modifier = Modifier
                .fillMaxSize()
                .padding(padding)
        ) {
            if (state.isLoading) {
                Box(Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
                    CircularProgressIndicator(color = DarkGold)
                }
            } else {
                Column(
                    modifier = Modifier
                        .fillMaxSize()
                        .verticalScroll(rememberScrollState())
                        .contentWidth(if (isExpanded) WideContentMaxWidth else ContentMaxWidth)
                        .padding(16.dp),
                    verticalArrangement = Arrangement.spacedBy(16.dp)
                ) {
                    // SH-148: an existing person's save runs on even if the form is left.
                    if (state.isEditMode && state.isSaving) SavingBanner()
                    // SH-192: someone of another workplace instead of a new person.
                    val picked = state.pickedPerson
                    if (!state.isEditMode && picked != null) {
                        PickedPersonCard(picked, enabled = !state.isSaving) { viewModel.onEvent(EmployeeFormEvent.ClearPickedPerson) }
                    } else if (state.showsFromOtherWorkplaces) {
                        FromOtherWorkplacesCard { showPeoplePicker = true }
                    }
                    // Wide windows: the sections in two columns; phones and tablets keep one column.
                    ResponsiveColumns(
                        maxColumns = if (isExpanded) 2 else 1,
                        sections = listOfNotNull<@Composable () -> Unit>(
                            {
                                ProfileSection(
                                    title = stringResource(Res.string.employee_basic_info),
                                    icon = Icons.Default.Person,
                                    onEdit = if (state.canEdit) { { viewModel.onEvent(EmployeeFormEvent.BeginSectionEdit); showBasicInfoEdit = true } } else null
                                ) {
                                    DataRow(
                                        stringResource(Res.string.settings_name),
                                        state.name.ifBlank { stringResource(Res.string.employee_not_set) })
                                    DataRow(
                                        stringResource(Res.string.roster_role),
                                        state.role.ifBlank { stringResource(Res.string.employee_not_set) })
                                }
                            },
                            {
                                ProfileSection(
                                    title = stringResource(Res.string.employee_permissions_settings),
                                    icon = Icons.Default.Settings,
                                    onEdit = if (state.canEdit) { { viewModel.onEvent(EmployeeFormEvent.BeginSectionEdit); showPermissionsEdit = true } } else null
                                ) {
                                    DataRow(
                                        stringResource(Res.string.employee_permission),
                                        state.permission.label()
                                    )
                                    DataRow(
                                        stringResource(Res.string.settings_skills),
                                        if (state.skills.isEmpty()) stringResource(Res.string.settings_none) else state.skills.joinToString(
                                            ", "
                                        )
                                    )
                                    DataRow(
                                        stringResource(Res.string.employee_is_primary),
                                        if (state.isPrimary) stringResource(Res.string.employee_yes) else stringResource(
                                            Res.string.employee_no
                                        )
                                    )
                                    // SH-47: on the engagement, like the role (colleagues schedule by it).
                                    DataRow(stringResource(Res.string.staff_competence), state.competence.label())
                                    // SH-270: the role's access and this person's modifications, on their own screen.
                                    val accessOf = state.employeeId
                                    if (state.isEditMode && state.canEdit && accessOf != null) {
                                        TextButton(onClick = { onOpenAccess(accessOf) }) {
                                            Text(stringResource(Res.string.access_open))
                                        }
                                    }
                                    // SH-255: their shifts out of their colleagues' sight; saved at once.
                                    state.hiddenInRoster?.takeIf { state.showsHiddenInRoster }?.let { hidden ->
                                        Row(
                                            Modifier.fillMaxWidth().padding(top = 8.dp).testTag(HIDDEN_IN_ROSTER_TAG).toggleable(
                                                value = hidden,
                                                enabled = state.canChangeHiddenInRoster,
                                                role = androidx.compose.ui.semantics.Role.Switch,
                                                onValueChange = { viewModel.onEvent(EmployeeFormEvent.SetHiddenInRoster(it)) }
                                            ),
                                            verticalAlignment = Alignment.CenterVertically
                                        ) {
                                            Column(Modifier.weight(1f)) {
                                                Text(stringResource(Res.string.employee_hidden_in_roster), color = DeepNavy, style = MaterialTheme.typography.bodyMedium)
                                                Text(
                                                    stringResource(Res.string.employee_hidden_in_roster_hint),
                                                    color = DeepNavy.copy(alpha = 0.6f),
                                                    style = MaterialTheme.typography.bodySmall
                                                )
                                            }
                                            androidx.compose.material3.Switch(
                                                checked = hidden,
                                                // The whole row toggles (one target, its label read with it).
                                                onCheckedChange = null,
                                                enabled = state.canChangeHiddenInRoster,
                                                modifier = Modifier.padding(start = 12.dp)
                                            )
                                        }
                                    }
                                }
                            },
                            // SH-47: medical exam and OHS. The dates for owners and financial
                            // managers, the statuses for operational managers.
                            if (state.showsStaffStatus) { {
                                ProfileSection(
                                    title = stringResource(Res.string.staff_checks_title),
                                    icon = Icons.Default.HealthAndSafety,
                                    onEdit = if (state.canEditStaffDates) { { viewModel.onEvent(EmployeeFormEvent.BeginSectionEdit); showStaffChecksEdit = true } } else null
                                ) {
                                    val readiness = state.readiness
                                    if (state.showsStaffDates) {
                                        StatusDataRow(
                                            stringResource(Res.string.staff_medical_valid_until),
                                            dateWithStatus(parseIsoDate(state.medicalValidUntil), readiness?.medical),
                                            readiness?.medical
                                        )
                                        DataRow(
                                            stringResource(Res.string.staff_ohs_training_date),
                                            parseIsoDate(state.ohsTrainingDate)?.let(::formatDay) ?: stringResource(Res.string.employee_not_set)
                                        )
                                        StatusDataRow(
                                            stringResource(Res.string.staff_ohs_valid_until),
                                            dateWithStatus(parseIsoDate(state.ohsValidUntil), readiness?.ohs),
                                            readiness?.ohs
                                        )
                                    } else {
                                        StatusDataRow(stringResource(Res.string.staff_medical_exam), dateWithStatus(null, readiness?.medical), readiness?.medical)
                                        StatusDataRow(stringResource(Res.string.staff_ohs_training), dateWithStatus(null, readiness?.ohs), readiness?.ohs)
                                        Text(
                                            stringResource(Res.string.staff_checks_status_only),
                                            style = MaterialTheme.typography.bodySmall,
                                            color = DeepNavy.copy(alpha = 0.55f)
                                        )
                                    }
                                }
                            } } else null,
                            // SH-122: contract, certificates and other files (the HR readers only).
                            if (state.showsDocuments) { {
                                ProfileSection(
                                    title = stringResource(Res.string.employee_documents),
                                    icon = Icons.Default.Description,
                                    onEdit = null
                                ) {
                                    Text(
                                        stringResource(Res.string.employee_documents_desc),
                                        style = MaterialTheme.typography.bodyMedium,
                                        color = DeepNavy.copy(alpha = 0.7f)
                                    )
                                    OutlinedButton(onClick = { state.employeeId?.let(onOpenDocuments) }) {
                                        Text(stringResource(Res.string.documents_open))
                                    }
                                }
                            } } else null,
                            // SH-212: what applies to the person from which day (owners, financial managers).
                            if (state.showsTimeline) { {
                                ProfileSection(
                                    title = stringResource(Res.string.employee_timeline),
                                    icon = Icons.Default.Timeline,
                                    onEdit = null
                                ) {
                                    Text(
                                        stringResource(Res.string.employee_timeline_desc),
                                        style = MaterialTheme.typography.bodyMedium,
                                        color = DeepNavy.copy(alpha = 0.7f)
                                    )
                                    OutlinedButton(onClick = { state.employeeId?.let(onOpenTimeline) }) {
                                        Text(stringResource(Res.string.timeline_open))
                                    }
                                }
                            } } else null,
                            if (state.showsStaffStatus) { {
                                ProfileSection(
                                    title = stringResource(Res.string.staff_notes_title),
                                    icon = Icons.Default.EditCalendar,
                                    onEdit = if (state.canEditNotes) { { viewModel.onEvent(EmployeeFormEvent.BeginSectionEdit); showNotesEdit = true } } else null
                                ) {
                                    Text(
                                        state.notes.ifBlank { stringResource(Res.string.settings_none) },
                                        style = MaterialTheme.typography.bodyMedium,
                                        color = DeepNavy.copy(alpha = if (state.notes.isBlank()) 0.55f else 1f)
                                    )
                                }
                            } } else null,
                            // Pay and personal data: financial managers and the owner only (MANAGE_PAY).
                            if (state.showsPayAndPrivateData) { {
                                ProfileSection(
                                    title = stringResource(Res.string.employee_financial_details),
                                    icon = Icons.Default.AccountBalanceWallet,
                                    onEdit = if (state.canEdit) { { viewModel.onEvent(EmployeeFormEvent.BeginSectionEdit); showFinancialEdit = true } } else null
                                ) {
                                    val notSet = stringResource(Res.string.employee_not_set)
                                    val contract = state.contract
                                    DataRow(
                                        stringResource(Res.string.employee_contract_type),
                                        if (contract == SystemContractType.NOT_SET) notSet else contractLabel(contract)
                                    )
                                    if (contract == SystemContractType.CIVIL_LAW_CONTRACT) {
                                        DataRow(
                                            stringResource(Res.string.employee_declared_hours),
                                            state.declaredNumberOfHours.ifBlank { notSet })
                                    }
                                    // SH-117: how the accountant's RCP files find this person.
                                    DataRow(stringResource(Res.string.employee_payroll_id), state.payrollId.ifBlank { notSet })
                                    DataRow(
                                        stringResource(Res.string.employee_model),
                                        if (state.isHourly) stringResource(Res.string.employee_hourly) else stringResource(
                                            Res.string.employee_monthly
                                        )
                                    )
                                    fun amount(value: String) = value.takeIf { it.isNotBlank() }
                                        ?.let { parseDecimal(it)?.let { number -> formatMoney(number, state.currency) } ?: "$it ${state.currency}" }
                                        ?: notSet
                                    if (state.isHourly) {
                                        DataRow(stringResource(Res.string.employee_rate), amount(state.rate))
                                    } else {
                                        DataRow(stringResource(Res.string.employee_salary), amount(state.baseSalary))
                                        DataRow(stringResource(Res.string.employee_fte_short), state.fte.ifBlank { notSet })
                                    }
                                    // SH-250: since when this pay applies, and a change already planned.
                                    PaySince(state.paySince, state.nextPay, state.currency)
                                    state.estimate?.let { PayEstimate(it, state.estimateHours, state.currency, onDark = false, factors = state.estimateFactors) }
                                    // SH-147: confirmed once, undone here.
                                    if (state.showsWorksUnpaid) {
                                        Row(
                                            Modifier.fillMaxWidth().padding(top = 8.dp).toggleable(
                                                value = state.worksUnpaid,
                                                enabled = state.canChangeWorksUnpaid,
                                                role = androidx.compose.ui.semantics.Role.Switch,
                                                onValueChange = { viewModel.onEvent(EmployeeFormEvent.SetWorksUnpaid(it)) }
                                            ),
                                            verticalAlignment = Alignment.CenterVertically
                                        ) {
                                            Column(Modifier.weight(1f)) {
                                                Text(
                                                    stringResource(Res.string.employee_works_unpaid, formatMoney(0.0, state.currency)),
                                                    color = DeepNavy,
                                                    style = MaterialTheme.typography.bodyMedium
                                                )
                                                Text(
                                                    stringResource(Res.string.employee_works_unpaid_hint),
                                                    color = DeepNavy.copy(alpha = 0.6f),
                                                    style = MaterialTheme.typography.bodySmall
                                                )
                                            }
                                            androidx.compose.material3.Switch(
                                                checked = state.worksUnpaid,
                                                // The whole row toggles (one target, its label read with it).
                                                onCheckedChange = null,
                                                enabled = state.canChangeWorksUnpaid,
                                                modifier = Modifier.padding(start = 12.dp)
                                            )
                                        }
                                    }
                                    // SH-206: whether the person counts in the labour figures (the owner too).
                                    state.labourInclusion?.takeIf { state.showsLabourInclusion }?.let { inclusion ->
                                        CountsInLabourRow(
                                            counts = inclusion.counts,
                                            worksWithoutWage = inclusion.worksWithoutWage,
                                            currency = state.currency,
                                            enabled = state.canChangeLabourInclusion,
                                            onChange = { viewModel.onEvent(EmployeeFormEvent.SetCountsInLabour(it)) }
                                        )
                                    }
                                    // SH-149: the dated changes of the pay and the statuses, newest first.
                                    if (state.termsHistory.isNotEmpty()) {
                                        Text(
                                            stringResource(Res.string.employee_terms_history),
                                            style = MaterialTheme.typography.labelMedium,
                                            modifier = Modifier.padding(top = 12.dp, bottom = 4.dp)
                                        )
                                        state.termsHistory.forEach { change ->
                                            DataRow(
                                                parseIsoDate(change.effectiveFrom)?.let(::formatDay) ?: change.effectiveFrom,
                                                termsChangeText(change, state.currency)
                                            )
                                        }
                                    }
                                }
                            } } else null,
                            if (state.showsPrivateData) { {
                                ProfileSection(
                                    title = stringResource(Res.string.employee_private_data),
                                    icon = Icons.Default.Lock,
                                    onEdit = if (state.canEdit) { { viewModel.onEvent(EmployeeFormEvent.BeginSectionEdit); showPrivateDataEdit = true } } else null
                                ) {
                                    DataRow(
                                        stringResource(Res.string.auth_email),
                                        state.email.ifBlank { stringResource(Res.string.employee_not_set) })
                                    DataRow(
                                        stringResource(Res.string.employee_phone),
                                        state.phoneNumber.ifBlank { stringResource(Res.string.employee_not_set) })
                                    DataRow(
                                        stringResource(Res.string.employee_address),
                                        state.address.ifBlank { stringResource(Res.string.employee_not_set) })
                                    DataRow(
                                        stringResource(Res.string.employee_bank_account),
                                        state.bankAccountNumber.ifBlank { stringResource(Res.string.employee_not_set) })
                                }
                            } } else null,
                            if (state.isEditMode && state.canEdit) { {
                                    ProfileSection(
                                        title = stringResource(Res.string.employee_app_usage),
                                        icon = Icons.Default.Smartphone,
                                        onEdit = null
                                    ) {
                                        DataRow(
                                            stringResource(Res.string.employee_has_app_account),
                                            if (!state.isShadow) stringResource(Res.string.employee_yes) else stringResource(
                                                Res.string.employee_no
                                            )
                                        )
                                        Spacer(Modifier.height(12.dp))
                                        Box(
                                            modifier = Modifier
                                                .fillMaxWidth()
                                                .height(44.dp)
                                                .background(GoldMetallicBrush, RoundedCornerShape(8.dp))
                                                .handCursor()
                                                .clickable(enabled = !state.isSaving) { viewModel.onEvent(EmployeeFormEvent.ShowInviteOptions) },
                                            contentAlignment = Alignment.Center
                                        ) {
                                            Text(
                                                stringResource(Res.string.employee_send_invite_options),
                                                fontWeight = FontWeight.Bold,
                                                color = DeepNavy
                                            )
                                        }
                                    }
                            } } else null
                        )
                    )

                    if (state.isEditMode && state.canEdit) {
                        // "More" Section for Removal
                        RegularCard(
                            modifier = Modifier.fillMaxWidth()
                        ) {
                            Column {
                                Row(
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .handCursor()
                                        .clickable { isMoreExpanded = !isMoreExpanded }
                                        .padding(horizontal = 16.dp, vertical = 16.dp),
                                    horizontalArrangement = Arrangement.SpaceBetween,
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    Row(verticalAlignment = Alignment.CenterVertically) {
                                        Icon(
                                            imageVector = Icons.Default.Settings,
                                            contentDescription = null,
                                            tint = DeepNavy,
                                            modifier = Modifier.size(20.dp)
                                        )
                                        Spacer(modifier = Modifier.width(12.dp))
                                        Text(
                                            text = stringResource(Res.string.settings_more),
                                            style = MaterialTheme.typography.titleSmall,
                                            fontWeight = FontWeight.Bold,
                                            color = DeepNavy
                                        )
                                    }
                                    Icon(
                                        imageVector = if (isMoreExpanded) Icons.Default.ExpandLess else Icons.Default.ExpandMore,
                                        contentDescription = null,
                                        tint = DeepNavy
                                    )
                                }

                                AnimatedVisibility(
                                    visible = isMoreExpanded,
                                    enter = expandVertically(animationSpec = tween(300)),
                                    exit = shrinkVertically(animationSpec = tween(300))
                                ) {
                                    Column(
                                        modifier = Modifier.padding(16.dp),
                                        verticalArrangement = Arrangement.spacedBy(16.dp)
                                    ) {
                                        HorizontalDivider(color = DeepNavy.copy(alpha = 0.1f))

                                        OutlinedButton(
                                            onClick = { showRemoveConfirmDialog = true },
                                            enabled = !state.isSaving,
                                            colors = ButtonDefaults.outlinedButtonColors(
                                                contentColor = Color(0xFFD32F2F)
                                            ),
                                            border = BorderStroke(1.dp, Color(0xFFD32F2F)),
                                            modifier = Modifier.fillMaxWidth()
                                        ) {
                                            Icon(Icons.Default.Delete, contentDescription = null)
                                            Spacer(Modifier.width(8.dp))
                                            Text(stringResource(Res.string.employee_remove))
                                        }
                                    }
                                }
                            }
                        }
                    }

                    Spacer(Modifier.height(32.dp))
                }
            }
        }
    }

    // --- DIALOGS ---
    // The dialogs edit the form in the view model (the pay estimate follows live); Cancel, back
    // and a tap outside put the section back as it was ([EmployeeFormEvent.CancelSectionEdit]).

    fun saveSection(close: () -> Unit) {
        if (state.isEditMode) viewModel.onEvent(EmployeeFormEvent.Submit)
        close()
    }

    if (showBasicInfoEdit) {
        val cancel = { viewModel.onEvent(EmployeeFormEvent.CancelSectionEdit); showBasicInfoEdit = false }
        EvoDialog(
            title = stringResource(Res.string.employee_edit_basic_info),
            icon = Icons.Default.Person,
            onDismiss = cancel,
            confirm = DialogAction(
                stringResource(Res.string.save),
                { saveSection { showBasicInfoEdit = false } },
                enabled = state.name.isNotBlank()
            )
        ) {
            EvoTextField(
                value = state.name,
                onValueChange = { viewModel.onEvent(EmployeeFormEvent.UpdateName(it)) },
                label = stringResource(Res.string.settings_name),
                // SH-192: someone of another workplace keeps their own name.
                readOnly = state.pickedPerson != null,
                capitalization = KeyboardCapitalization.Words,
                error = stringResource(Res.string.field_required).takeIf { state.name.isBlank() }
            )
            RoleField(
                role = state.role,
                onRoleChange = { viewModel.onEvent(EmployeeFormEvent.UpdateRole(it)) },
                availableRoles = state.availableRoles,
                imeAction = ImeAction.Done
            )
        }
    }

    if (showPeoplePicker) {
        OtherWorkplacePeopleDialog(
            people = state.otherWorkplacePeople,
            onPick = { person ->
                viewModel.onEvent(EmployeeFormEvent.PickPersonFromOtherWorkplace(person.user.uid))
                showPeoplePicker = false
            },
            onDismiss = { showPeoplePicker = false }
        )
    }

    if (showPermissionsEdit) {
        val cancel = { viewModel.onEvent(EmployeeFormEvent.CancelSectionEdit); showPermissionsEdit = false }
        EvoDialog(
            title = stringResource(Res.string.employee_edit_permissions),
            icon = Icons.Default.Settings,
            onDismiss = cancel,
            bodyArrangement = Arrangement.spacedBy(24.dp),
            confirm = DialogAction(stringResource(Res.string.save), { saveSection { showPermissionsEdit = false } })
        ) {
            DialogSection(stringResource(Res.string.dialog_section_access)) {
                EvoDropdown(
                    label = stringResource(Res.string.employee_permission),
                    options = state.availablePermissions,
                    selected = state.permission,
                    onSelected = { viewModel.onEvent(EmployeeFormEvent.UpdatePermission(it)) },
                    optionLabel = { it.label() }
                )
            }

            if (state.availableSkills.isNotEmpty()) {
                DialogSection(stringResource(Res.string.settings_skills)) {
                    Column {
                        state.availableSkills.forEach { skill ->
                            EvoCheckboxRow(
                                checked = skill in state.skills,
                                onCheckedChange = { viewModel.onEvent(EmployeeFormEvent.ToggleSkill(skill)) },
                                label = skill
                            )
                        }
                    }
                }
            }

            // SH-47: who needs supervision (SH-104: who leads is the workplace's lead positions and skills).
            DialogSection(stringResource(Res.string.staff_competence)) {
                EvoSegmented(
                    options = Competence.entries.toList(),
                    selected = state.competence,
                    onSelect = { viewModel.onEvent(EmployeeFormEvent.UpdateCompetence(it)) },
                    optionLabel = { it.label() }
                )
                Text(stringResource(Res.string.staff_competence_hint), color = Color.White.copy(alpha = 0.6f), style = MaterialTheme.typography.bodySmall)
            }

            DialogSection(stringResource(Res.string.dialog_section_engagement)) {
                Column {
                    EvoSwitchRow(
                        checked = state.isPrimary,
                        onCheckedChange = { viewModel.onEvent(EmployeeFormEvent.UpdateIsPrimary(it)) },
                        label = stringResource(Res.string.employee_primary_workplace),
                        supporting = stringResource(Res.string.employee_primary_workplace_hint)
                    )
                }
            }
        }
    }

    if (showFinancialEdit) {
        val cancel = { viewModel.onEvent(EmployeeFormEvent.CancelSectionEdit); showFinancialEdit = false }
        val numberError = stringResource(Res.string.number_invalid)
        fun invalid(value: String) = value.isNotBlank() && parseDecimal(value) == null
        val hoursInvalid = state.contract == SystemContractType.CIVIL_LAW_CONTRACT &&
            state.declaredNumberOfHours.isNotBlank() && state.declaredNumberOfHours.trim().toIntOrNull() == null
        val payInvalid = if (state.isHourly) invalid(state.rate) else invalid(state.baseSalary) || invalid(state.fte)
        EvoDialog(
            title = stringResource(Res.string.employee_edit_financial_details),
            icon = Icons.Default.AccountBalanceWallet,
            onDismiss = cancel,
            dismissOnClickOutside = false,
            bodyArrangement = Arrangement.spacedBy(24.dp),
            confirm = DialogAction(
                stringResource(Res.string.save),
                { saveSection { showFinancialEdit = false } },
                enabled = !hoursInvalid && !payInvalid && !state.knownEndInvalid
            )
        ) {
            DialogSection(stringResource(Res.string.dialog_section_contract)) {
                ContractDropdown(
                    selected = state.contract,
                    onSelected = { viewModel.onEvent(EmployeeFormEvent.UpdateContractType(it.name)) }
                )
                if (state.contract == SystemContractType.CIVIL_LAW_CONTRACT) {
                    EvoTextField(
                        value = state.declaredNumberOfHours,
                        onValueChange = { viewModel.onEvent(EmployeeFormEvent.UpdateDeclaredNumberOfHours(it)) },
                        label = stringResource(Res.string.employee_declared_hours),
                        keyboardType = KeyboardType.Number,
                        error = numberError.takeIf { hoursInvalid }
                    )
                }
                // SH-117: the number in the payroll software, which matches the RCP export files.
                EvoTextField(
                    value = state.payrollId,
                    onValueChange = { viewModel.onEvent(EmployeeFormEvent.UpdatePayrollId(it)) },
                    label = stringResource(Res.string.employee_payroll_id),
                    supportingText = stringResource(Res.string.employee_payroll_id_help),
                    keyboardType = KeyboardType.Number
                )
            }

            DialogSection(stringResource(Res.string.dialog_section_pay)) {
                EvoSegmented(
                    options = listOf(true, false),
                    selected = state.isHourly,
                    onSelect = { viewModel.onEvent(EmployeeFormEvent.UpdateIsHourly(it)) },
                    optionLabel = { stringResource(if (it) Res.string.employee_hourly else Res.string.employee_monthly) }
                )
                if (state.isHourly) {
                    EvoTextField(
                        value = state.rate,
                        onValueChange = { viewModel.onEvent(EmployeeFormEvent.UpdateRate(it)) },
                        label = stringResource(Res.string.employee_rate_unit),
                        keyboardType = KeyboardType.Decimal,
                        error = numberError.takeIf { invalid(state.rate) },
                        suffix = state.currency,
                        // SH-133: the owner or a partner costs nothing unless they set a notional amount.
                        supportingText = if (state.contract == SystemContractType.OWNER_PARTNER) {
                            stringResource(Res.string.employee_owner_partner_rate_hint)
                        } else null
                    )
                } else {
                    Row(horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                        EvoTextField(
                            value = state.baseSalary,
                            onValueChange = { viewModel.onEvent(EmployeeFormEvent.UpdateBaseSalary(it)) },
                            label = stringResource(Res.string.employee_salary_unit),
                            keyboardType = KeyboardType.Decimal,
                            error = numberError.takeIf { invalid(state.baseSalary) },
                            suffix = state.currency,
                            modifier = Modifier.weight(2f)
                        )
                        EvoTextField(
                            value = state.fte,
                            onValueChange = { viewModel.onEvent(EmployeeFormEvent.UpdateFte(it)) },
                            label = stringResource(Res.string.employee_fte),
                            keyboardType = KeyboardType.Decimal,
                            error = numberError.takeIf { invalid(state.fte) },
                            modifier = Modifier.weight(1f)
                        )
                    }
                }
            }

            PayrollProfileSwitches(
                contract = state.contract,
                profile = state.payrollProfile,
                onChange = { viewModel.onEvent(EmployeeFormEvent.UpdatePayrollProfile(it)) }
            )
            // SH-57: changed pay applies from a day; the days before keep the stored pay.
            // SH-149: one day for the pay and the payroll facts changed together.
            if (state.termsChanged) {
                Column(verticalArrangement = Arrangement.spacedBy(4.dp)) {
                    EvoDateField(
                        value = state.rateEffectiveFrom,
                        onValueChange = { viewModel.onEvent(EmployeeFormEvent.UpdateRateEffectiveFrom(it)) },
                        label = stringResource(Res.string.employee_rate_effective_from)
                    )
                    Text(
                        stringResource(Res.string.employee_rate_effective_from_hint),
                        color = Color.White.copy(alpha = 0.75f),
                        style = MaterialTheme.typography.bodySmall
                    )
                }
            }
            state.estimate?.let { PayEstimate(it, state.estimateHours, state.currency, onDark = true, factors = state.estimateFactors) }
        }
    }

    if (showPrivateDataEdit) {
        val cancel = { viewModel.onEvent(EmployeeFormEvent.CancelSectionEdit); showPrivateDataEdit = false }
        EvoDialog(
            title = stringResource(Res.string.employee_edit_private_data),
            icon = Icons.Default.Lock,
            onDismiss = cancel,
            bodyArrangement = Arrangement.spacedBy(24.dp),
            confirm = DialogAction(stringResource(Res.string.save), { saveSection { showPrivateDataEdit = false } })
        ) {
            DialogSection(stringResource(Res.string.dialog_section_contact)) {
                EvoTextField(
                    value = state.email,
                    onValueChange = { viewModel.onEvent(EmployeeFormEvent.UpdateEmail(it.trim())) },
                    label = stringResource(Res.string.auth_email),
                    keyboardType = KeyboardType.Email,
                    leadingIcon = Icons.Default.Email
                )
                EvoTextField(
                    value = state.phoneNumber,
                    onValueChange = { viewModel.onEvent(EmployeeFormEvent.UpdatePhoneNumber(it)) },
                    label = stringResource(Res.string.employee_phone),
                    keyboardType = KeyboardType.Phone,
                    leadingIcon = Icons.Default.Phone
                )
                EvoTextField(
                    value = state.address,
                    onValueChange = { viewModel.onEvent(EmployeeFormEvent.UpdateAddress(it)) },
                    label = stringResource(Res.string.employee_address),
                    leadingIcon = Icons.Default.Home
                )
            }
            DialogSection(stringResource(Res.string.dialog_section_bank)) {
                EvoTextField(
                    value = state.bankAccountNumber,
                    onValueChange = { viewModel.onEvent(EmployeeFormEvent.UpdateBankAccount(it)) },
                    label = stringResource(Res.string.employee_bank_account),
                    keyboardType = KeyboardType.Number,
                    imeAction = ImeAction.Done,
                    leadingIcon = Icons.Default.AccountBalance
                )
            }
        }
    }

    // SH-47: the dates only (never results); the statuses follow on save.
    if (showStaffChecksEdit) {
        val cancel = { viewModel.onEvent(EmployeeFormEvent.CancelSectionEdit); showStaffChecksEdit = false }
        val problem = state.staffDatesProblem
        EvoDialog(
            title = stringResource(Res.string.staff_checks_edit),
            icon = Icons.Default.HealthAndSafety,
            onDismiss = cancel,
            dismissOnClickOutside = false,
            bodyArrangement = Arrangement.spacedBy(20.dp),
            confirm = DialogAction(
                stringResource(Res.string.save),
                { viewModel.onEvent(EmployeeFormEvent.SaveStaffChecks); showStaffChecksEdit = false },
                enabled = state.typedStaffRecord != null && problem == null
            )
        ) {
            Text(stringResource(Res.string.staff_checks_dates_only), color = Color.White.copy(alpha = 0.75f), style = MaterialTheme.typography.bodySmall)
            DialogSection(stringResource(Res.string.staff_medical_exam)) {
                EvoDateField(
                    value = state.medicalValidUntil,
                    onValueChange = { viewModel.onEvent(EmployeeFormEvent.UpdateMedicalValidUntil(it)) },
                    label = stringResource(Res.string.staff_medical_valid_until),
                    missingYear = MissingYear.Upcoming
                )
            }
            DialogSection(stringResource(Res.string.staff_ohs_training)) {
                EvoDateField(
                    value = state.ohsTrainingDate,
                    onValueChange = { viewModel.onEvent(EmployeeFormEvent.UpdateOhsTrainingDate(it)) },
                    label = stringResource(Res.string.staff_ohs_training_date)
                )
                EvoDateField(
                    value = state.ohsValidUntil,
                    onValueChange = { viewModel.onEvent(EmployeeFormEvent.UpdateOhsValidUntil(it)) },
                    label = stringResource(Res.string.staff_ohs_valid_until),
                    missingYear = MissingYear.Upcoming,
                    imeAction = ImeAction.Done,
                    error = stringResource(Res.string.staff_ohs_valid_before_training).takeIf { problem == StaffRecordProblem.OHS_VALID_BEFORE_TRAINING }
                )
            }
        }
    }

    if (showNotesEdit) {
        val cancel = { viewModel.onEvent(EmployeeFormEvent.CancelSectionEdit); showNotesEdit = false }
        EvoDialog(
            title = stringResource(Res.string.staff_notes_edit),
            icon = Icons.Default.EditCalendar,
            onDismiss = cancel,
            confirm = DialogAction(stringResource(Res.string.save), { viewModel.onEvent(EmployeeFormEvent.SaveNotes); showNotesEdit = false })
        ) {
            EvoTextField(
                value = state.notes,
                onValueChange = { viewModel.onEvent(EmployeeFormEvent.UpdateNotes(it)) },
                label = stringResource(Res.string.staff_notes_title),
                singleLine = false,
                minLines = 3,
                imeAction = ImeAction.Default
            )
            Text(stringResource(Res.string.staff_notes_hint), color = Color.White.copy(alpha = 0.6f), style = MaterialTheme.typography.bodySmall)
        }
    }

    if (state.showInviteDialogAfterCreation) {
        EvoDialog(
            title = stringResource(Res.string.employee_invitation_options),
            icon = Icons.Default.Email,
            onDismiss = { viewModel.onEvent(EmployeeFormEvent.DismissInviteDialog) },
            width = DialogWidth.Compact,
            dismissible = !state.isSaving,
            confirm = null,
            dismiss = DialogAction(stringResource(Res.string.done), { viewModel.onEvent(EmployeeFormEvent.DismissInviteDialog) }),
            bodyArrangement = Arrangement.spacedBy(12.dp)
        ) {
            if (state.email.isNotBlank()) {
                EvoPrimaryButton(
                    DialogAction(
                        stringResource(Res.string.employee_send_invite_email),
                        { viewModel.onEvent(EmployeeFormEvent.SendInvite) },
                        loading = state.isSaving,
                        icon = Icons.Default.Email
                    ),
                    Modifier.fillMaxWidth()
                )
            }
            // Creates a real invitation; the code dialog then offers copying it.
            EvoSecondaryButton(
                DialogAction(
                    stringResource(Res.string.employee_copy_link),
                    { viewModel.onEvent(EmployeeFormEvent.CreateInviteCode) },
                    enabled = !state.isSaving,
                    icon = Icons.Default.ContentCopy
                ),
                Modifier.fillMaxWidth()
            )
            state.inviteError?.let { inviteError ->
                Text(inviteError.asString(), color = ErrorOnNavy, style = MaterialTheme.typography.bodySmall)
            }
        }
    }

    if (showRemoveConfirmDialog) {
        EvoConfirmDialog(
            title = stringResource(Res.string.employee_remove),
            text = stringResource(Res.string.employee_remove_confirm),
            confirmLabel = stringResource(Res.string.employee_remove),
            onConfirm = {
                viewModel.onEvent(EmployeeFormEvent.RemoveEmployee)
                showRemoveConfirmDialog = false
            },
            onDismiss = { showRemoveConfirmDialog = false },
            destructive = true,
            icon = Icons.Default.Delete
        )
    }
}

/** SH-148: "Saving changes… You can leave this screen: the save will finish." */
/** SH-192: "From your other workplaces" above a new person's form. */
@Composable
private fun FromOtherWorkplacesCard(onChoose: () -> Unit) {
    RegularCard(modifier = Modifier.fillMaxWidth()) {
        Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Icon(Icons.Default.Groups, contentDescription = null, tint = DeepNavy, modifier = Modifier.size(20.dp))
                Spacer(Modifier.width(12.dp))
                Text(
                    stringResource(Res.string.employee_from_other_workplaces),
                    style = MaterialTheme.typography.titleSmall,
                    fontWeight = FontWeight.Bold,
                    color = DeepNavy
                )
            }
            Text(
                stringResource(Res.string.employee_from_other_workplaces_hint),
                style = MaterialTheme.typography.bodyMedium,
                color = DeepNavy.copy(alpha = 0.75f)
            )
            OutlinedButton(onClick = onChoose, modifier = Modifier.fillMaxWidth()) {
                Text(stringResource(Res.string.employee_choose_person), color = DeepNavy, fontWeight = FontWeight.Bold)
            }
        }
    }
}

/** SH-192: the person picked from another workplace, with the way back to a new person. */
@Composable
private fun PickedPersonCard(person: OtherWorkplacePerson, enabled: Boolean, onClear: () -> Unit) {
    RegularCard(modifier = Modifier.fillMaxWidth()) {
        Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                com.evoapps.evoshift.widgets.UserAvatar(name = person.user.displayName, photoUrl = person.user.photoUrl, size = 40.dp)
                Spacer(Modifier.width(12.dp))
                Text(
                    stringResource(Res.string.employee_picked_from_other, person.user.displayName, person.workplaceName),
                    style = MaterialTheme.typography.bodyMedium,
                    color = DeepNavy,
                    modifier = Modifier.weight(1f)
                )
            }
            OutlinedButton(onClick = onClear, enabled = enabled, modifier = Modifier.fillMaxWidth()) {
                Text(stringResource(Res.string.employee_add_someone_new), color = DeepNavy)
            }
        }
    }
}

/** SH-192: the people of the viewer's other workplaces: photo, name, their workplace and role. */
@Composable
private fun OtherWorkplacePeopleDialog(
    people: List<OtherWorkplacePerson>,
    onPick: (OtherWorkplacePerson) -> Unit,
    onDismiss: () -> Unit
) {
    EvoDialog(
        title = stringResource(Res.string.employee_from_other_workplaces),
        icon = Icons.Default.Groups,
        onDismiss = onDismiss,
        bodyArrangement = Arrangement.spacedBy(4.dp)
    ) {
        people.forEach { person ->
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .clip(RoundedCornerShape(12.dp))
                    .handCursor()
                    .clickable { onPick(person) }
                    .padding(horizontal = 8.dp, vertical = 10.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                com.evoapps.evoshift.widgets.UserAvatar(name = person.user.displayName, photoUrl = person.user.photoUrl, size = 40.dp)
                Spacer(Modifier.width(12.dp))
                Column(Modifier.weight(1f)) {
                    Text(person.user.displayName, color = Color.White, fontWeight = FontWeight.Bold)
                    Text(
                        listOfNotNull(person.workplaceName.takeIf { it.isNotBlank() }, person.role).joinToString(" · "),
                        color = Color.White.copy(alpha = 0.7f),
                        style = MaterialTheme.typography.bodySmall
                    )
                }
            }
        }
    }
}

@Composable
private fun SavingBanner() {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(12.dp))
            .background(DeepNavy.copy(alpha = 0.06f))
            .padding(horizontal = 16.dp, vertical = 12.dp)
            .testTag(EMPLOYEE_SAVING_TAG),
        verticalAlignment = Alignment.CenterVertically
    ) {
        CircularProgressIndicator(modifier = Modifier.size(18.dp), color = DarkGold, strokeWidth = 2.dp)
        Spacer(Modifier.width(12.dp))
        Text(stringResource(Res.string.saves_saving_hint), color = DeepNavy, style = MaterialTheme.typography.bodyMedium)
    }
}

/** SH-148: the form's "Saving…" banner (robots find it by this tag). */
const val EMPLOYEE_SAVING_TAG = "employee_saving"

/** SH-250: the tag of the line saying since when the pay applies (robots find it by it). */
const val PAY_SINCE_TAG = "employee_pay_since"

/**
 * SH-250: "Since 1 October 2026" under the pay, and a change already planned after it ("From
 * 1 November: 32,00 zł an hour"; the year only when it is not this one).
 */
@Composable
private fun PaySince(since: String?, next: com.evoapps.evoshift.domain.model.RatePeriod?, currency: String) {
    val sinceDay = since?.let(::parseIsoDate)
    val nextDay = next?.let { parseIsoDate(it.effectiveFrom) }
    if (sinceDay == null && nextDay == null) return
    val thisYear = com.evoapps.evoshift.domain.util.AppClock.todayIn(kotlinx.datetime.TimeZone.currentSystemDefault()).year
    val lines = buildList {
        sinceDay?.let { add(stringResource(Res.string.employee_pay_since, com.evoapps.evoshift.widgets.longDate(it))) }
        if (next != null && nextDay != null) {
            val day = if (nextDay.year == thisYear) com.evoapps.evoshift.ui.util.dayAndMonth(nextDay) else com.evoapps.evoshift.widgets.longDate(nextDay)
            val pay = when (val terms = next.compensation) {
                is com.evoapps.evoshift.domain.model.CompensationModel.Hourly -> stringResource(Res.string.payroll_rate_hourly, formatMoney(terms.rate, currency))
                is com.evoapps.evoshift.domain.model.CompensationModel.MonthlyFixed -> stringResource(Res.string.payroll_rate_monthly, formatMoney(terms.baseSalary, currency))
            }
            add(stringResource(Res.string.employee_pay_next, day, pay))
        }
    }
    Text(
        lines.joinToString(" · "),
        style = MaterialTheme.typography.bodySmall,
        color = DeepNavy.copy(alpha = 0.7f),
        modifier = Modifier.fillMaxWidth().padding(bottom = 4.dp).testTag(PAY_SINCE_TAG)
    )
}

/** SH-206: the tag of "Count in labour cost and SPMH" (robots find the row by it). */
const val COUNTS_IN_LABOUR_TAG = "employee_counts_in_labour"

/** SH-255: the tag of "Hide in the roster for others" (robots find the row by it). */
const val HIDDEN_IN_ROSTER_TAG = "employee_hidden_in_roster"

/**
 * SH-206: "Count in labour cost and SPMH", one switch for the hours and the cost together, with
 * what it does; for someone counted without a wage, that their hours count at no cost.
 */
@Composable
private fun CountsInLabourRow(counts: Boolean, worksWithoutWage: Boolean, currency: String, enabled: Boolean, onChange: (Boolean) -> Unit) {
    Row(
        Modifier.fillMaxWidth().padding(top = 8.dp).testTag(COUNTS_IN_LABOUR_TAG).toggleable(
            value = counts,
            enabled = enabled,
            role = androidx.compose.ui.semantics.Role.Switch,
            onValueChange = onChange
        ),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Column(Modifier.weight(1f)) {
            Text(stringResource(Res.string.employee_counts_in_labour), color = DeepNavy, style = MaterialTheme.typography.bodyMedium)
            Text(
                stringResource(Res.string.employee_counts_in_labour_hint),
                color = DeepNavy.copy(alpha = 0.6f),
                style = MaterialTheme.typography.bodySmall
            )
            if (counts && worksWithoutWage) {
                Text(
                    stringResource(Res.string.employee_counts_in_labour_no_wage, formatMoney(0.0, currency)),
                    color = DeepNavy.copy(alpha = 0.6f),
                    style = MaterialTheme.typography.bodySmall,
                    modifier = Modifier.padding(top = 2.dp)
                )
            }
        }
        androidx.compose.material3.Switch(
            checked = counts,
            // The whole row toggles (one target, its label read with it).
            onCheckedChange = null,
            enabled = enabled,
            modifier = Modifier.padding(start = 12.dp)
        )
    }
}
